import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const Path = props => <motion.path fill="transparent" strokeWidth="3" stroke="#2E2E2E" strokeLinecap="round" {...props} />;

const Button = styled.button`
  outline: none;
  border: none;
  user-select: none;
  cursor: pointer;
  pointer-events: all;
  background: transparent;
`;

export const MenuToggle = ({ toggle }) => (
  <Button onClick={toggle}>
    <svg width="23" height="23" viewBox="0 0 23 23" style={{ marginLeft: '3px' }}>
      <Path
        variants={{
          closed: { d: 'M 2 2.5 L 20 2.5', stroke: 'white' },
          open: { d: 'M 3 16.5 L 17 2.5', stroke: 'white' },
        }}
      />
      <Path
        d="M 2 9.423 L 20 9.423"
        variants={{
          closed: { opacity: 1, stroke: 'white' },
          open: { opacity: 0, stroke: 'white' },
        }}
        transition={{ duration: 0.1 }}
      />
      <Path
        variants={{
          closed: { d: 'M 2 16.346 L 20 16.346', stroke: 'white' },
          open: { d: 'M 3 2.5 L 17 16.346', stroke: 'white' },
        }}
      />
    </svg>
  </Button>
);
